import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarnTriangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30.455,
	height: 26.914,
	viewBox: "0 0 30.455 26.914",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Polygon_37",
		"data-name": "Polygon 37",
		d: "M11.746,6.153a4,4,0,0,1,6.963,0l8.369,14.791a4,4,0,0,1-3.481,5.97H6.859a4,4,0,0,1-3.481-5.97Z",
		fill: "#d72f6e"
	})]
});
const ForwardRef = forwardRef(SvgWarnTriangle);
export { ForwardRef as ReactComponent };
